import {
  ROI_SAVE_DATA_SUCCESS,
  ROI_SAVE_DATA_FAILURE,
  ROI_GET_DATA_REQUEST,
  ROI_GET_DATA_SUCCESS,
  ROI_GET_DATA_FAILURE,
  ROI_GET_DETAILS_SUCCESS,
  ROI_GET_ALL_DETAILS_SUCCESS,
  ROI_GET_DETAILS_FAILURE,
  ROI_DELETE_SUCCESS,
  ROI_DELETE_FAILURE,
  ROI_CLEAR_DETAILS  
} from './actions';

import {
  ROI_GET_VENDORDATA_SUCCESS
} from './meta-actions';

import createReducer from 'state/createReducer';
import _ from 'lodash';

const initialState = {
  errorMessage: '',
  errorCode: 999,
  request: false,
  list: [],
  details: {
    calcVars: {},
    createdByUser: {},
    id: null,
    items: [],
    vendor: {},
    standaloneCalc: false,
    showOnVendorProfile: false
  },
  allModelsSkusByID: new Map(),
  meta: {
    vendors: []
  }
};

const handlers = {

  [ROI_GET_DATA_REQUEST](state) {
    return {
      ...state,
      request: true,
      errorMessage: null
    }
  },

  [ROI_GET_DATA_SUCCESS](state, payload) {

    let data = payload
    if (data === null) {
      data = [];
    }

    return {
      ...state,
      request: false,
      errorMessage: null,
      list: data
    }
  },

  [ROI_GET_DATA_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: payload.errorMessage
    }
  },
  
  [ROI_CLEAR_DETAILS](state) {
    return {
      ...state,
      errorCode: 999,
      errorMessage: null,
      details: {
        calcVars: {},
        createdByUser: {},
        id: null,
        items: [],
        vendor: {},
        standaloneCalc: false,
        showOnVendorProfile: false
      },      
    }
  },

  [ROI_GET_DETAILS_SUCCESS](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: null,
      errorCode: 999,
      details: {
        calcVars: _.get(payload, 'calcVars', {}),
        createdByUser: _.get(payload, 'createdByUser', {}),
        id: _.get(payload, 'id', null),
        items: _.get(payload, 'items', []),
        vendor: _.get(payload, 'vendor', {}),
        standaloneCalc: _.get(payload, 'standaloneCalc', false),
        showOnVendorProfile: _.get(payload, 'showOnVendorProfile', false)
      }
    };
  },

  
  [ROI_GET_ALL_DETAILS_SUCCESS](state, payload) {
    const allModelsSkusByID = new Map();
    payload.forEach(el => {
      allModelsSkusByID.set(el.id, el)
    });
    return {
      ...state,
      request: false,
      errorMessage: null,
      errorCode: 999,
      allModelsSkusByID
    };
  },

  [ROI_GET_DETAILS_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: _.get(payload, 'errorMessage', ''),
      errorCode: _.get(payload, 'code', 999)
    }
  },

  [ROI_SAVE_DATA_SUCCESS](state, payload) {

    return {
      ...state,
    }
  },

  [ROI_SAVE_DATA_FAILURE](state, payload) {

    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  },

  [ROI_DELETE_SUCCESS](state, payload) {
    return {
      ...state
    }
  },

  [ROI_DELETE_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: payload.errorMessage
    }
  },

  [ROI_GET_VENDORDATA_SUCCESS](state, payload) {
    return {
      ...state,
      meta: {
        vendors: _.get(payload, 'vendors', [])
      }
    }
  }
}

export default (state = initialState, action) => createReducer(state, action, handlers); 